import { createFileRoute, Outlet, useChildMatches, useRouter } from '@tanstack/react-router';
import { MembershipDetailPanel } from '@/components/organisms/memberships/MembershipDetailPanel';
import { MembershipFormPanel } from '@/components/organisms/memberships/MembershipFormPanel';
import {
  MEMBERSHIP_DETAIL_SEARCH,
  MEMBERSHIP_LIST_SEARCH,
} from '@/lib/memberships/membership-route-search';

export const Route = createFileRoute('/_dashboard/dashboard/memberships/$id')({
  component: MembershipDetailRoute,
});

function MembershipDetailRoute() {
  const { id } = Route.useParams();
  const childMatches = useChildMatches();
  const router = useRouter();

  if (id === 'new') {
    return (
      <MembershipFormPanel
        onCancel={() =>
          void router.navigate({ to: '/dashboard/memberships', search: MEMBERSHIP_LIST_SEARCH })
        }
        onCreated={(created) =>
          void router.navigate({
            to: '/dashboard/memberships/$id',
            params: { id: created.id },
            search: MEMBERSHIP_DETAIL_SEARCH,
            replace: true,
          })
        }
      />
    );
  }

  if (childMatches.length > 0) return <Outlet />;

  return <MembershipDetailPanel id={id} />;
}
